import React from 'react';
import getActiveCom from './liveChatRequest/liveChatGetActiveCom';

export default function UserListing(props) {

    return (
        <ul>
            <li key="userComTitle" className="comChoosenTitle">
                Conversations en cours
            </li>
            <br></br>
            {props.state
                && props.state.com_list
                && props.state.com_list.length > 0
                && props.state.com_list.map((item, index) => {
                    var fullname = 
                        item.user_firstname + " " +
                        item.user_lastname + " (" +
                        item.user_pseudo + ")";

                return (
                    <li
                        key={"userCom" + index}
                        className={
                            item.new_message === 0
                                ? "comChoosen"
                                : "comChoosen mark_unread_message"
                            }
                        style={{
                            background:
                            props.state.current_communication === fullname
                                ? 'rgba(100, 200, 200, 0.4)'
                                : 'grey'
                            }}
                        onClick={() => { 
                            props.dispatch({
                                type: 'change_current_communication',
                                payload: {current_communication: fullname}
                            });
                            if (props.state.active_operator_id !== 0) {
                                props.dispatch({
                                    type: 'change_chat_id',
                                    payload: {chat_id: item.chat_id}
                                });
                                clearInterval(props.oneComInterval.current);
                                getActiveCom(props.state, item.chat_id, props.dispatch);
                                props.oneComInterval.current =
                                    setInterval(() => 
                                        getActiveCom(props.state, item.chat_id, props.dispatch),
                                        3000,
                                    );
                            } else {
                                props.dispatch({
                                    type: 'change_current_communication',
                                    payload: {current_communication: ''}
                                });
                                clearInterval(props.oneComInterval.current);
                            }
                        }}>
                        {fullname}
                    </li>
                )
            })}
        </ul>
    )
}
